import { PathOptions } from "leaflet";

export const municipios_pe = (feature: any): PathOptions => {
  return {
    color: "#000000ff",
    weight: 1,
    opacity: 1,
    fillColor: "transparent",
    fillOpacity: 0,
  };
};
